import NotificationSettingSharing from "@app/types/notifications/NotificationSettingSharing";

const getSharingUpdate = (enabled: boolean): NotificationSettingSharing => ({
  activityAssigned: enabled,
  emailTemplate: enabled,
  enabled,
  folder: enabled,
  groups: enabled,
  ownership: enabled,
  resource: enabled,
  routes: enabled,
  savedFilter: enabled,
});

export default getSharingUpdate;
